export default __webpack_public_path__ + "static/media/screenShots_astramed-2.995753af.jpg";